import {CifMoneyModel} from '../../../../model/cif/cif-money.model';

export class CifPremiumModel {

    totalPremiumText: string;
    vat: CifMoneyModel;
    premium: CifMoneyModel;

}
